// captureUtils.jsx
// Shared utilities for all summit capture tabs
// Provides consistent owner picklists, status selects, date pickers

export const TCC_OWNERS = [
  "Dan Frasco",
  "Vanessa Fucciani", 
  "Martin Lopez",
  "Mike Dansby",
  "Rachel Hopper",
  "Dave Smith",
  "Sab Guerriero",
  "Burke",
  "Monica",
  "Clare",
  "Cassie",
  "Chase",
  "Jeff",
  "Clay",
  "Taylor",
  "Amanda",
  "Sarah",
  "Kalynn",
  "Annae",
  "Alexis",
  "Desirae",
  "Danielle",
  "Samantha",
  "Sean",
  "Lisa",
  "TBD at summit",
  "TBD",
];

export const WORKSTREAM_STATUSES = [
  { value: "open",        label: "Open",        color: "#6b7280" },
  { value: "in-progress", label: "In Progress", color: "#e67e22" },
  { value: "confirmed",   label: "Confirmed",   color: "#27ae60" },
  { value: "at-risk",     label: "At Risk",     color: "#c0392b" },
  { value: "deferred",    label: "Deferred",    color: "#8e44ad" },
  { value: "done",        label: "Done",        color: "#27ae60" },
];

export const GUARDRAIL_STATUSES = [
  { value: "not-started", label: "Not Started", color: "#6b7280" },
  { value: "drafted",     label: "Drafted",     color: "#e67e22" },
  { value: "agreed",      label: "Agreed",      color: "#2980b9" },
  { value: "signed-off",  label: "Signed Off",  color: "#27ae60" },
];

export const DECISION_STATUSES = [
  { value: "open",             label: "Open",             color: "#6b7280" },
  { value: "under discussion", label: "Under Discussion", color: "#e67e22" },
  { value: "decided",          label: "Decided",          color: "#27ae60" },
  { value: "deferred",         label: "Deferred",         color: "#8e44ad" },
];

export const PHASES = [
  "Phase 1",
  "Phase 1-2",
  "Phase 2",
  "Phase 2-3",
  "Phase 3",
  "Phase 3-4",
  "Phase 4",
  "CIM",
  "Ongoing",
  "Day 2 output",
  "Summit output",
];

export const DUE_DATES = [
  "End Phase 1",
  "Summit Day 2",
  "Within 1 week",
  "Week 1",
  "Week 1-2",
  "Week 2-3",
  "Week 3-4",
  "Week 4",
  "Week 4-6",
  "Week 6-8",
  "Week 8-10",
  "End Phase 2",
  "Phase 3",
  "End Phase 3",
  "Q3 2026",
  "Q4 2026",
  "Dec 2026",
  "Jan 2027",
  "Q1 2027",
  "Q2 2027",
  "Q3 2027",
  "TBD",
];

const INPUT_BASE = {
  width: "100%",
  padding: "6px 10px",
  fontSize: 12,
  border: "1px solid #e5e7eb",
  borderRadius: 6,
  background: "#fff",
  color: "#1a1a2e",
  boxSizing: "border-box",
};

// Owner field as proper select dropdown
export function OwnerInput({ value, onChange, placeholder, style }) {
  return (
    <select
      value={value || ""}
      onChange={onChange}
      style={{ ...INPUT_BASE, ...style }}
    >
      <option value="">{placeholder || "Select owner..."}</option>
      {TCC_OWNERS.map(function(o) {
        return <option key={o} value={o}>{o}</option>;
      })}
    </select>
  );
}

// Status select with color indicator
export function StatusSelect({ value, onChange, options, style }) {
  const opts = options || WORKSTREAM_STATUSES;
  const current = opts.find(function(o) { return o.value === value; }) || opts[0];
  return (
    <select
      value={value || ""}
      onChange={onChange}
      style={{
        ...INPUT_BASE,
        color: current.color,
        fontWeight: 700,
        ...style,
      }}
    >
      {opts.map(function(o) {
        return <option key={o.value} value={o.value} style={{ color: o.color, fontWeight: 700 }}>{o.label}</option>;
      })}
    </select>
  );
}

// Due date field as proper select dropdown
export function DueDateInput({ value, onChange, style }) {
  return (
    <select value={value || ""} onChange={onChange} style={{ ...INPUT_BASE, ...style }}>
      <option value="">Select due date...</option>
      {DUE_DATES.map(function(d) {
        return <option key={d} value={d}>{d}</option>;
      })}
    </select>
  );
}

// Phase select
export function PhaseSelect({ value, onChange, style }) {
  return (
    <select value={value || ""} onChange={onChange} style={{ ...INPUT_BASE, ...style }}>
      <option value="">Select phase...</option>
      {PHASES.map(function(p) {
        return <option key={p} value={p}>{p}</option>;
      })}
    </select>
  );
}

// Date picker (actual calendar picker)
export function DatePicker({ value, onChange, placeholder, style }) {
  return (
    <input
      type="date"
      value={value || ""}
      onChange={onChange}
      placeholder={placeholder || ""}
      style={{ ...INPUT_BASE, ...style }}
    />
  );
}

// Small compact versions for table rows
export function OwnerInputSm({ value, onChange }) {
  return (
    <select
      value={value || ""}
      onChange={onChange}
      style={{ width: "100%", padding: "3px 6px", fontSize: 11, border: "1px solid #e5e7eb", borderRadius: 4, background: "#fff", color: "#1a1a2e" }}
    >
      <option value="">Select owner...</option>
      {TCC_OWNERS.map(function(o) { return <option key={o} value={o}>{o}</option>; })}
    </select>
  );
}

export function DueDateInputSm({ value, onChange }) {
  return (
    <select
      value={value || ""}
      onChange={onChange}
      style={{ width: "100%", padding: "3px 6px", fontSize: 11, border: "1px solid #e5e7eb", borderRadius: 4, background: "#fff", color: "#1a1a2e" }}
    >
      <option value="">Select due...</option>
      {DUE_DATES.map(function(d) { return <option key={d} value={d}>{d}</option>; })}
    </select>
  );
}

export function StatusSelectSm({ value, onChange, options }) {
  const opts = options || WORKSTREAM_STATUSES;
  const current = opts.find(function(o) { return o.value === value; }) || opts[0];
  return (
    <select
      value={value || "open"}
      onChange={onChange}
      style={{ width: "100%", padding: "3px 6px", fontSize: 11, border: "1px solid #e5e7eb", borderRadius: 4, background: "#fff", color: current.color, fontWeight: 700 }}
    >
      {opts.map(function(o) {
        return <option key={o.value} value={o.value} style={{ color: o.color }}>{o.label}</option>;
      })}
    </select>
  );
}
